import LoginWithButton from "../LoginwithButton";
import google from "./../../assets/google.png";
import { googleLogin } from "./ApiService";
export default function LoginWithGoogleButton() {
  const handleLogin = async () => {
    try {
      const redirectLink = await googleLogin();
      console.log("Login successful:", redirectLink);
      window.location.href = redirectLink;
    } catch (err) {
      console.error("Login failed:", err);
      // setError(err.message || "Login failed");
    }
  };
  return (
    <LoginWithButton iconimg={google} iconname="Google" onClick={handleLogin} />
  );
}
